var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimebrif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8.32801,
    fill: "#FFF8ED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1968_24825)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1968_24825",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H7V23H23V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1968_24825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0026 19.6321C13.2559 19.6321 11.8359 18.2121 11.8359 16.4655C11.8359 14.7188 13.2559 13.2988 15.0026 13.2988C16.7493 13.2988 18.1693 14.7188 18.1693 16.4655C18.1693 18.2121 16.7493 19.6321 15.0026 19.6321ZM15.0026 14.2988C13.8093 14.2988 12.8359 15.2721 12.8359 16.4655C12.8359 17.6588 13.8093 18.6321 15.0026 18.6321C16.1959 18.6321 17.1693 17.6588 17.1693 16.4655C17.1693 15.2721 16.1959 14.2988 15.0026 14.2988Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 17.633C14.1666 17.633 13.9999 17.5463 13.9066 17.393C13.7666 17.153 13.8399 16.8463 14.0799 16.7063L14.5866 16.3996C14.6399 16.373 14.6666 16.313 14.6666 16.2596V15.6396C14.6666 15.3663 14.8933 15.1396 15.1666 15.1396C15.4399 15.1396 15.6666 15.3596 15.6666 15.633V16.253C15.6666 16.6596 15.4466 17.0463 15.0999 17.253L14.5933 17.5596C14.5133 17.613 14.4199 17.633 14.3333 17.633Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6681 22.1669H12.3348C9.25479 22.1669 8.68145 20.7335 8.53479 19.3402L8.03479 14.0002C7.96145 13.3002 7.94145 12.2668 8.63479 11.4935C9.23479 10.8268 10.2281 10.5068 11.6681 10.5068H18.3348C19.7815 10.5068 20.7748 10.8335 21.3681 11.4935C22.0615 12.2668 22.0415 13.3002 21.9681 14.0069L21.4681 19.3335C21.3215 20.7335 20.7481 22.1669 17.6681 22.1669ZM11.6681 11.5002C10.5415 11.5002 9.76812 11.7202 9.37479 12.1602C9.04812 12.5202 8.94145 13.0735 9.02812 13.9002L9.52812 19.2402C9.64145 20.2935 9.92812 21.1669 12.3348 21.1669H17.6681C20.0681 21.1669 20.3615 20.2935 20.4748 19.2335L20.9748 13.9069C21.0615 13.0735 20.9548 12.5202 20.6281 12.1602C20.2348 11.7202 19.4615 11.5002 18.3348 11.5002H11.6681Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6693 11.4997C17.3959 11.4997 17.1693 11.273 17.1693 10.9997V10.4663C17.1693 9.27967 17.1693 8.83301 15.5359 8.83301H14.4693C12.8359 8.83301 12.8359 9.27967 12.8359 10.4663V10.9997C12.8359 11.273 12.6093 11.4997 12.3359 11.4997C12.0626 11.4997 11.8359 11.273 11.8359 10.9997V10.4663C11.8359 9.29301 11.8359 7.83301 14.4693 7.83301H15.5359C18.1693 7.83301 18.1693 9.29301 18.1693 10.4663V10.9997C18.1693 11.273 17.9426 11.4997 17.6693 11.4997Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6776 16.5922C17.4509 16.5922 17.2509 16.4389 17.1909 16.2122C17.1242 15.9456 17.2842 15.6722 17.5509 15.6056C18.8509 15.2789 20.0576 14.7122 21.1376 13.9256C21.3576 13.7656 21.6709 13.8122 21.8376 14.0389C21.9976 14.2589 21.9509 14.5722 21.7242 14.7389C20.5376 15.5989 19.2176 16.2189 17.7909 16.5789C17.7576 16.5856 17.7176 16.5922 17.6776 16.5922Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3338 16.6128C12.2938 16.6128 12.2538 16.6061 12.2138 16.5994C10.8738 16.2728 9.61382 15.7061 8.46048 14.9194C8.23382 14.7661 8.17382 14.4528 8.32715 14.2261C8.48048 13.9994 8.79382 13.9394 9.02048 14.0928C10.0738 14.8128 11.2205 15.3261 12.4471 15.6261C12.7138 15.6928 12.8805 15.9594 12.8138 16.2328C12.7671 16.4594 12.5605 16.6128 12.3338 16.6128Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1968_24825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimebrif);
export default __webpack_public_path__ + "static/media/timebrif.b80da5dc4b8c700a857b49a2420a95e8.svg";
export { ForwardRef as ReactComponent };